<!-- Question addition page -->
<section class="mt-3">
  <kl-survey-add-question
  [surveyId]="dialogData?.data?.surveyId"
  (questionAdded)="onQuestionAddition($event)">
</kl-survey-add-question>
</section>
<!-- / Question addition page -->
